import React from 'react';
import '../../App.css';

interface FooterProps {
  children: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  return (
    <footer className="app-footer">
      {children}
    </footer>
  );
};

export default Footer;
